import {Text, Flex, Box, Image} from '@chakra-ui/react';
import {useGeolocation} from '../../hooks/geolocation';
import {theme} from '../../style/theme';
import {Logo} from '../global/logo';

interface PiecePanelProps {
  status: string;
  price: string;
  pieces: string;
  color: string;
  image?: string;
}

export const PiecePanel: React.FC<PiecePanelProps> = ({
  status,
  price,
  pieces,
  color,
  image,
}) => {
  const {currency, currencyPostfix} = useGeolocation();

  return (
    <Box w="100%">
      <Flex
        justify={{
          base: 'space-between',
          sm: 'flex-start',
        }}
        align="center"
        flexWrap="nowrap"
        my="24px"
        width="100%"
      >
        <Box width={{base: '100px', lg: '70px'}} mr={{base: '0', sm: '32px'}}>
          <Logo base={theme.colors.white} accent={color} />
        </Box>
        <Box
          mr={{base: '0', sm: '32px'}}
          display={{base: 'flex', lg: 'block'}}
          justifyContent={{base: 'center'}}
          alignItems={{base: 'center'}}
          flexWrap="wrap"
        >
          <Text
            as="span"
            textStyle="h2news_1c"
            fontStyle="normal"
            display={{base: 'block', sm: 'inline'}}
            w={{base: '100%'}}
            textAlign={{base: 'center'}}
            pr={{lg: '8px'}}
          >
            {pieces}
          </Text>{' '}
          <Text
            as="span"
            textStyle="h6_1c"
            w={{base: '100%'}}
            textAlign={{base: 'center'}}
          >
            Pieces
          </Text>
        </Box>
        {status !== 'MARKETPLACE' && (
          <Box
            mr={{base: '0', sm: '32px'}}
            display={{base: 'flex', lg: 'block'}}
            justifyContent={{base: 'center'}}
            alignItems={{base: 'center'}}
            flexWrap="wrap"
          >
            <Text
              as="span"
              textStyle="h2news_1c"
              fontStyle="normal"
              display={{base: 'block', sm: 'inline'}}
              w={{base: '100%'}}
              textAlign={{base: 'center'}}
              pr={{lg: '8px'}}
            >
              {currency || ''}
              {price || ''}
              <Text as="span" fontSize="0.7em">
                {currencyPostfix}
              </Text>
            </Text>{' '}
            <Text
              as="span"
              textStyle="h6_1c"
              w={{base: '100%'}}
              textAlign={{base: 'center'}}
            >
              per Piece
            </Text>
          </Box>
        )}
      </Flex>
      {image && (
        <Flex
          w="100%"
          justifyContent={{base: 'center', lg: 'start'}}
          alignItems="center"
          pt={{base: '16px', lg: 0}}
          pb={{base: '16px', lg: 0}}
        >
          <Text w="99px" textStyle="h7_1c" textAlign="end" mr="16px">
            In partnership with
          </Text>
          <Box w="174px">
            <Image
              src="/assets/baldwin-logo-white-landscape.svg"
              alt="baldwin's logo"
            />
          </Box>
        </Flex>
      )}
      <Box
        pt={{base: '20px', lg: '70px'}}
        display={{base: 'none', lg: 'inline-block'}}
      >
        <Flex w="100%" justify={{base: 'center'}} align="center">
          <Image
            src="/assets/white-down-arrorw.svg"
            alt="downwards arrow"
            height="16px"
            width="16px"
            mr="8px"
          />
          <Text textStyle="body3_1c" color="white">
            Read the story
          </Text>
        </Flex>
      </Box>
    </Box>
  );
};
